import type { Commit } from "vuex";
import type { Solution } from "@/store/types";
import { getLicencesForOrg, clearLicencesCache } from "@/utils/licenceApi";

interface State {
  solutions: Solution[];
}

const state: State = {
  solutions: [],
};

const getters = {
  solutions: (state: State) => state.solutions,
};

const actions = {
  resetState({ commit }: { commit: Commit }) {
    commit("setSolutions", []);
    clearLicencesCache();
  },
  async getSolutions(
    { commit }: { commit: Commit },
    { uuid }: { uuid: string },
  ) {
    if (!uuid) {
      throw new Error("Organisation ID is not provided");
    }

    const data = (await getLicencesForOrg(uuid)) as {
      licences?: Solution[];
      data?: { licences?: Solution[] };
    };
    commit("setSolutions", data.licences ?? data?.data?.licences ?? []);
  },
};

const mutations = {
  setSolutions: (state: State, data: Solution[]) => (state.solutions = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
